import { render } from "./UserMenuAndJoin.vue.js?vue&type=template&id=7736c4ea!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./UserMenuAndJoin.vue?vue&type=template&id=7736c4ea"
import script from "./UserMenuAndJoin.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./UserMenuAndJoin.vue?vue&type=script&lang=js"
export * from "./UserMenuAndJoin.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./UserMenuAndJoin.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/SharedWeb/scripts/dynamic-component-editor/standard-elements/UserMenuAndJoin.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7736c4ea"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7736c4ea', __exports__)) {
    api.reload('7736c4ea', __exports__)
  }
  
  module.hot.accept("./UserMenuAndJoin.vue.js?vue&type=template&id=7736c4ea!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./UserMenuAndJoin.vue?vue&type=template&id=7736c4ea", () => {
    api.rerender('7736c4ea', render)
  })

}


export default __exports__